// extracted by mini-css-extract-plugin
export default {"textArea":"BannedWordListConfig-textArea-3ba4424e536d273cf80424c221924191"};